import styled from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

import { Container } from '@components/ions/layouts';

import { maxWidth } from '@utils/helpers';

export const SuccessTemplateWrapper = styled(Container)`
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    position: relative;
`;

export const InfoWrapper = styled.div`
    max-width: 592px;
    text-align: center;

    ${maxWidth('xxs')} {
        max-width: 316px;
    }
`;

export const SuccessIconWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 40px;

    ${maxWidth('xxs')} {
        margin-bottom: 32px;
    }
`;

export const InfoText = styled(Typography.TextH4_20_28)`
    margin-top: 16px;
    margin: 16px auto 0;
    max-width: 524px;
`;
